export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  createdOn: { field: 'createdOn', fieldType: 'date' },
  customerCode: { field: 'customerCode', fieldType: 'text' },
  customerId: { field: 'customerID', fieldType: 'numeric', isLookupID: true },
  customerName: { field: 'customerName', fieldType: 'text' },
  email: { field: 'email', fieldType: 'text', required: true, type: 'email' },
  hasAdministratorAccess: {
    field: 'hasAdministratorAccess',
    fieldType: 'boolean',
    title: 'Admin?'
  },
  hasGlobalAccess: { field: 'hasGlobalAccess', fieldType: 'boolean', title: 'Global?' },
  hasThirdPartyAccess: {
    field: 'hasThirdPartyAccess',
    fieldType: 'boolean',
    title: 'Third Party?'
  },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' },
  thirdParty: { field: 'thirdParty', fieldType: 'text' },
  userId: { field: 'userID', fieldType: 'numeric' },
  username: { field: 'username', fieldType: 'text', required: true }
};
